// extracted by mini-css-extract-plugin
export default {"container":"EmployeeList_container__XrZpL","employeeListContainer":"EmployeeList_employeeListContainer__TamX5"};